import { useSelector } from "react-redux";
import { selectUserData } from "../redux/features/userState/userStateSlice";

export const useAuth = () => {
  const userData = useSelector(selectUserData);
  const isAuthenticated = userData !== null;

  return { isAuthenticated, userData };
};
